// Mock appointments data for the dashboard

export const todayAppointments = [
  {
    id: 1,
    patientName: "John Smith",
    time: "09:00 AM",
    doctor: "Dr. Alex Morgan",
    doctorSpecialty: "AI General Physician",
    type: "General Checkup",
    status: "upcoming",
    notes: "",
    symptoms: "Routine wellness check"
  },
  {
    id: 2,
    patientName: "Sarah Johnson",
    time: "10:30 AM",
    doctor: "Dr. Sophia Khan",
    doctorSpecialty: "AI Mental Health Therapist",
    type: "Mental Health",
    status: "in-progress",
    notes: "Follow-up on anxiety management",
    symptoms: "Anxiety, stress at work"
  },
  {
    id: 3,
    patientName: "Michael Brown",
    time: "11:00 AM",
    doctor: "Dr. Daniel Smith",
    doctorSpecialty: "AI Cardiologist",
    type: "Cardiology",
    status: "upcoming",
    notes: "",
    symptoms: "Heart palpitations, occasional chest discomfort"
  },
  {
    id: 4,
    patientName: "Emily Davis",
    time: "02:00 PM",
    doctor: "Dr. Olivia Chen",
    doctorSpecialty: "AI Dietitian / Nutritionist",
    type: "Nutrition",
    status: "upcoming",
    notes: "",
    symptoms: "Weight management consultation"
  },
  {
    id: 5,
    patientName: "Robert Wilson",
    time: "03:30 PM",
    doctor: "Dr. Ethan Brown",
    doctorSpecialty: "AI Orthopedic Doctor",
    type: "Orthopedic",
    status: "upcoming",
    notes: "",
    symptoms: "Lower back pain for 2 weeks"
  },
  {
    id: 6,
    patientName: "Jennifer Lee",
    time: "04:00 PM",
    doctor: "Dr. Maya Gupta",
    doctorSpecialty: "AI Neurologist",
    type: "Neurology",
    status: "upcoming",
    notes: "",
    symptoms: "Recurring headaches, migraines"
  }
];

export const recentPatients = [
  {
    id: 1,
    name: "John Smith",
    lastVisit: "2025-07-24",
    doctor: "Dr. Alex Morgan",
    condition: "General Wellness"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    lastVisit: "2025-07-23",
    doctor: "Dr. Sophia Khan",
    condition: "Anxiety Management"
  },
  {
    id: 3,
    name: "Michael Brown",
    lastVisit: "2025-07-22",
    doctor: "Dr. Daniel Smith",
    condition: "Cardiac Monitoring"
  },
  {
    id: 4,
    name: "Emily Davis",
    lastVisit: "2025-07-21",
    doctor: "Dr. Olivia Chen",
    condition: "Nutrition Plan"
  },
  {
    id: 5,
    name: "Robert Wilson",
    lastVisit: "2025-07-20",
    doctor: "Dr. Ethan Brown",
    condition: "Back Pain Treatment"
  }
];

export default { todayAppointments, recentPatients };
